import { PageLocatorMap } from '../types/PageLocatorMap';

export const signUpPinVerifyPage = {
  alert: {
    error: 'signup-pin-verify-page.alert.error',
    success: 'signup-pin-verify-page.alert.success',
  },
  footer: {
    root: 'signup-pin-verify-page.footer.root',
  },
  form: {
    h1: 'signup-pin-verify-page.form.heading1',
    h3: 'signup-pin-verify-page.form.heading3',
    pinInput1: 'signup-pin-verify-page.form.pin-input-1',
    pinInput2: 'signup-pin-verify-page.form.pin-input-2',
    pinInput3: 'signup-pin-verify-page.form.pin-input-3',
    pinInput4: 'signup-pin-verify-page.form.pin-input-4',
    pinInput5: 'signup-pin-verify-page.form.pin-input-5',
    pinInput6: 'signup-pin-verify-page.form.pin-input-6',
    pinInputError: 'signup-pin-verify-page.form.pin-error',
    resendPinLink: 'signup-pin-verify-page.form.resend-pin-link',
    root: 'signup-pin-verify-page.form.root',
  },
  header: {
    root: 'signup-pin-verify-page.header.root',
    signUpLink: 'signup-pin-verify-page.header.signup-link',
  },
} as const satisfies PageLocatorMap;
